import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { Label, Table, Button } from 'semantic-ui-react'
import firebase from '../../config/firebase'
import utils from '../../utils'

class PartnerRow extends Component {
  state = {
    removing: false,
  }

  onRemoveClick = key => {
    const self = this
    const confirmation = window.confirm('Are you sure to delete?')

    if (confirmation === true) {
      this.setState({ removing: true })

      firebase
        .database()
        .ref(`/partners/${key}`)
        .remove()
        .then(() => {
          self.setState({ removing: false })
        })
    }
  }

  isLogged = loggedUUID => {
    if (loggedUUID) {
      return (
        <div>
          <Label color="green">Logged</Label>
        </div>
      )
    }
    return <Label color="red">Never</Label>
  }

  render() {
    const { removing } = this.state
    const { fireKey, data } = this.props

    const {
      tel,
      loggedUUID,
      family_name: familyName,
      first_name: firstName,
      restaurant_name: restaurantName,
      branch_name: branchName,
      last_session: lastSession,
      current_version: version,
    } = data

    const username = `${familyName} ${firstName}`

    return (
      <Table.Row>
        <Table.Cell> {username} </Table.Cell>
        <Table.Cell> {tel} </Table.Cell>
        <Table.Cell textAlign="center">{restaurantName || '...'}</Table.Cell>
        <Table.Cell textAlign="center">{branchName || '...'}</Table.Cell>
        <Table.Cell textAlign="center">{this.isLogged(loggedUUID)}</Table.Cell>
        <Table.Cell textAlign="center">
          {utils.helpers.getLoggedDevicePlatform(loggedUUID)}
          {version && (
            <Label>
              {version}
              {data.code_push_version ? `-${data.code_push_version}` : ''}
            </Label>
          )}
        </Table.Cell>
        <Table.Cell textAlign="center">{lastSession ? moment(lastSession).fromNow() : ''}</Table.Cell>
        <Table.Cell textAlign="center">
          <Link to={`/partners/${fireKey}/edit`}>
            <Button size="tiny"> Edit </Button>
          </Link>
          <Button size="tiny" color="red" loading={removing} onClick={() => this.onRemoveClick(fireKey)}>
            Delete
          </Button>
        </Table.Cell>
      </Table.Row>
    )
  }
}

export default PartnerRow



// WEBPACK FOOTER //
// ./src/components/partners/row.js